import React, { ReactNode } from 'react'

import ListItemButton from 'components_new/atoms/List/ListItemButton'
import ListItemIcon from 'components_new/atoms/List/ListItemIcon'
import Icon, { IconProps } from 'components_new/atoms/Icon'
import ListItemText from 'components_new/atoms/List/ListItemText'
import ListItemSecondaryAction from 'components_new/atoms/List/ListItemSecondaryAction'
import Switch from 'components_new/atoms/Switch'

interface FormToggleProps {
  body: string
  disabled?: boolean
  icon?: IconProps | ReactNode
  onChange: (value: boolean) => void
  sx?: object
  value: boolean
  title: string
}

const FormToggle = React.forwardRef((props: FormToggleProps, ref: any) => {
  const { body, disabled, icon, onChange, sx, title, value } = props

  return (
    <ListItemButton
      disabled={disabled}
      onClick={() => onChange(!value)}
      ref={ref}
      sx={{ bgcolor: 'background.default', mb: 1, ...sx }}
    >
      {icon ? (
        <ListItemIcon sx={{ minWidth: 0, mr: 2 }}>
          {typeof icon === 'object' ? <Icon {...(icon as IconProps)} /> : icon}
        </ListItemIcon>
      ) : null}
      <ListItemText
        primary={title}
        secondary={body}
        secondaryTypographyProps={{ color: 'text.secondary' }}
      />
      <ListItemSecondaryAction>
        <Switch checked={value} onChange={() => {}} value={value} />
      </ListItemSecondaryAction>
    </ListItemButton>
  )
})

FormToggle.displayName = 'FormToggle'
export default FormToggle
